import React, { useEffect, useState } from 'react';

const DEFAULT_INTERVAL_MS = 1400;

/**
 * Floating magenta status FAB with rotating quips (events / places loading).
 *
 * @param {{
 *   active: boolean;
 *   phrases: string[];
 *   intervalMs?: number;
 * }} props
 */
const PublicLoadingFab = ({ active, phrases, intervalMs = DEFAULT_INTERVAL_MS }) => {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const list = Array.isArray(phrases) && phrases.length > 0 ? phrases : ['Loading'];

  useEffect(() => {
    if (!active) {
      setPhraseIndex(0);
      return undefined;
    }
    const id = window.setInterval(() => {
      setPhraseIndex((i) => (i + 1) % list.length);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [active, intervalMs, list.length]);

  if (!active) return null;

  const phrase = list[phraseIndex % list.length];

  return (
    <div
      className="pub-events-loading-fab"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="pub-events-loading-fab__plus" aria-hidden="true">
        +
      </span>
      <span
        key={phrase}
        className="pub-events-loading-fab__label pub-events-loading-fab__label--swap"
      >
        {phrase}
      </span>
    </div>
  );
};

export default PublicLoadingFab;
